import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './Context/theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

<ThemeProvider>
<App />
</ThemeProvider>
    
 
);


reportWebVitals();
